import { IMakeRequest, isSuccessResponse } from '../../../utils/network_helper';
import { TThunkAction } from '../../../types/redux';
import { IGeoBoundedBy, IGeocodeError } from '../../../types/filters/user_geo';
import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
} from '../../../constants/geoSwitcher';

const VALID_REGION_MAPPER: Record<number, number> = {
  [MOSCOW_WITH_AREA_REGION_ID]: MOSCOW_AREA_REGION_ID,
  [ST_PETERSBURG_WITH_AREA_REGION_ID]: ST_PETERSBURG_AREA_REGION_ID,
};

export function getBbox(makeRequest: IMakeRequest, regionOrMaintownId: number): Promise<IGeoBoundedBy> {
  return makeRequest({
    method: 'GET',
    uri: {
      path: `/cian-api/site/v1/get-location/`,
      query: `regionId=${regionOrMaintownId}`,
    },
  }).then((response: IGeoBoundedBy | IGeocodeError) => {
    if (!isSuccessResponse<IGeoBoundedBy, IGeocodeError>(response, 'data')) {
      throw new Error();
    }

    return response;
  });
}

export function getGeoBbox(regionOrMaintownId: number): TThunkAction<Promise<IGeoBoundedBy>> {
  return (dispatch, getState, context) => {
    const region = VALID_REGION_MAPPER[regionOrMaintownId] || regionOrMaintownId;

    return getBbox(context.makeRequest, region);
  };
}
